import { Button, Card, Input, Modal, Tooltip } from "antd";
import axios from "axios";
import React from "react";
import ReCAPTCHA from "react-google-recaptcha";
import IdleTimer from "react-idle-timer";
import { Alert } from "rsuite";
import { Context } from "../../Context";
import infoIcon from "../../assets/images/info-icon.png";
import timer from "../../assets/images/timer.svg";
import constants from "../../constants";
import fieldConstants from "../../fieldConstants";
import services from "../../services";
import { TimeoutContext } from "../../services/Contexts/TimeoutContext";
import Loader from "../Loader";
import { Input2 } from "../common";

import "../../assets/styles/two_ui_ctrl.css";

const hostname = window.location.hostname;
const recaptchaRef = React.createRef();
const formFields = [
	{
		name: "email",
		label: "Email Address",
		type: "email",
		class: "single-element",
		invalidMsg: "This is not valid email address",
	},
	{
		name: "password",
		label: "Password",
		type: "password",
		class: "single-element",
		invalidMsg:
			"The email id and password don't match. Click on forgot password to change",
	},
];

const api = services.api;

class LoginPopUp extends React.Component {
	static contextType = Context;
	constructor(props) {
		super(props);
		this.state = {
			formData: {
				firstName: null,
				lastName: null,
				email: null,
				password: null,
				otp: null,
			},
			valid: {
				email: null,
				password: null,
				valid: null,
			},
			loginError: null,
			showPassword: false,
			recaptchaValidation: null,
			recpatchaValue: null,
			loading: false,
			pageRedirectionLoading: false,
			disableButton: false,
			otp: null,
			otp_sent: false,
			otp_validated: false,
			req_type: null,
			enableResendBtn: true,
			incorrect_otp: false,
			otp_errMsg: null,
			disableContinue: false,
			isCodeIncorrect: false,
			alertTime: 300000,
			visible: false,
			timeout: this.props.timeout,
		};
		this.interval = React.createRef(null);
		this.onSubmit = this.onSubmit.bind(this);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.timeout !== this.props.timeout) {
			this.setState({
				timeout: this.props.timeout,
			});
		}
	}

	componentDidMount() {
		this.interval.current = setInterval(
			() => this.checkExpirationTime(window.localStorage.getItem("user_token")),
			60000,
		);
	}

	componentWillUnmount() {
		console.log("Clearing token interval timer");
		clearInterval(this.interval.current);
	}

	checkExpirationTime = (token) => {
		if (token) {
			const url = window.location.href.substr(
				window.location.href.lastIndexOf("/") + 1,
			);
			const value =
				Date.now() >=
				JSON.parse(window.atob(token.split(".")[1])).exp * 1000 - 60000;
			if (
				value &&
				url &&
				!["signin", "signup", "forgot-password"].includes(url.toLowerCase()) &&
				!this.state.visible
			) {
				const form = this.state.formData;
				const validate = this.state.valid;
				const email = window.localStorage.getItem("email");
				window.localStorage.clear();
				if (email) {
					validate.valid = true;
					validate.email = email;
					form.email = email;
					window.localStorage.setItem("email", email);
				}
				this.setState({ visible: value, formData: form, valid: validate });
			}
		}
	};

	onloaderStart = () => {
		this.setState({ loading: true });
	};

	onloadingComplete = () => {
		this.setState({ loading: false });
	};

	onrelogin = () => {
		this.setState({
			otp_sent: false,
			disableButton: false,
			otp: null,
			otp_validated: false,
			req_type: null,
			enableResendBtn: true,
			incorrect_otp: false,
			otp_errMsg: null,
			disableContinue: false,
			isCodeIncorrect: false,
		});
		Alert.closeAll();
	};

	handleOnAction = (event) => {
		console.log("Active on: ", new Date());
		const now = new Date();
		// Set new timeout expire time
		window.localStorage.setItem(
			"expireTime",
			now.getTime() + 1000 * 60 * this.state.timeout,
		);
	};

	handleOnIdle = (event) => {
		console.log("Idle on: ", new Date());
		const now = new Date();
		if (now.getTime() > Number(window.localStorage.getItem("expireTime"))) {
			const url = window.location.href.substr(
				window.location.href.lastIndexOf("/") + 1,
			);
			if (
				url &&
				!["signin", "signup", "forgot-password"].includes(url.toLowerCase())
			) {
				const form = this.state.formData;
				const validate = this.state.valid;
				const email = window.localStorage.getItem("email");
				window.localStorage.clear();
				if (email) {
					validate.valid = true;
					validate.email = email;
					form.email = email;
					window.localStorage.setItem("email", email);
				}
				this.setState({ visible: true, formData: form, valid: validate });
			} else {
				window.localStorage.setItem(
					"expireTime",
					now.getTime() + 1000 * 60 * this.state.timeout,
				);
			}
		}
	};

	render() {
		const captchaCrtls = () => {
			return (
				<form onSubmit={this.onSubmit} autoComplete="on">
					{formFields.map((item, index) => (
						<Input2
							containerClass=""
							type={item.type}
							name={item.name}
							placeholder={item.label}
							disabled={
								!!(
									item.name === "email" && window.localStorage.getItem("email")
								)
							}
							value={this.state.formData[item.name]}
							onChange={this.inputEntered}
							key={item.name}
							id={`custom-css-outlined-input_${index}`}
							getValid={this.captureValidFlag}
							showPassword={this.state.showPassword}
							handleClickShowPassword={() => {
								this.showPasswordHandler();
							}}
						/>
					))}
					{this.state.loginError ? (
						<div style={{ height: 20 }}>
							<span className="error-msg">{this.state.loginError}</span>
						</div>
					) : null}
					{constants.captcha_whitelist.includes(hostname) && (
						<div className={"captcha-container recaptcha-container"}>
							<ReCAPTCHA
								sitekey={constants.recaptchaSitekey}
								onChange={this.onChangeRecaptcha}
								onExpired={this.onExpiredRecaptcha}
								onErrored={this.onErrorRecaptcha}
								size="normal"
								ref={recaptchaRef}
							/>
						</div>
					)}

					<button
						className="btn btn-primary-cta signin-button"
						disabled={
							this.state.disableButton ||
							constants.captcha_whitelist.includes(hostname)
								? !this.state.valid.valid || !this.state.recaptchaValidation
								: !this.state.valid.valid
						}
						type="submit"
					>
						Sign In
					</button>
				</form>
			);
		};

		const tfa_ctrl_grid = () => {
			return (
				<Card
					title="Two-Factor Authentication"
					headStyle={{ fontWeight: "bold" }}
					bodyStyle={{ textAlign: "left" }}
				>
					<p>{fieldConstants.tfa_info}</p>
					<br />
					<p style={{ width: "35%" }}>
						Two-Factor Code &nbsp; &nbsp;
						<Tooltip title={fieldConstants.tfa_tooltip}>
							<img
								src={infoIcon}
								style={{ cursor: "pointer", marginLeft: "-10px" }}
								alt="info icon"
							/>
						</Tooltip>
					</p>
					<Input
						className="otp_user_cssid"
						placeholder="Code"
						style={{ width: "65%" }}
						value={this.state.otp}
						onChange={this.onChangeOtp}
						type="number"
					/>
					{this.state.isCodeIncorrect && !this.state.disableContinue ? (
						<p style={{ color: "red" }}>
							Incorrect 2FA code. Re-enter the correct code
						</p>
					) : (
						""
					)}
					{this.state.disableContinue ? (
						<p>
							Incorrect 2FA code.{" "}
							<a
								style={{ color: "blue" }}
								// biome-ignore lint/a11y/useValidAnchor: <explanation>
								onClick={() => {
									this.onrelogin();
								}}
								onKeyUp={(e) => {
									if (e.key === "Enter") {
										this.onrelogin();
									}
								}}
							>
								Re-login
							</a>{" "}
							again
						</p>
					) : (
						""
					)}
					<div>
						<br />
						<Button
							className="tfa_btn"
							disabled={this.state.disableContinue}
							type="primary"
							htmlType="submit"
						>
							<span className="tfa_text">Continue</span>
						</Button>
					</div>
					{this.state.otp_sent &&
					!this.state.enableResendBtn &&
					!this.state.disableContinue ? (
						<p>Email sent! Enter the code above.</p>
					) : (
						""
					)}
					{this.state.enableResendBtn &&
					this.state.otp_sent &&
					!this.state.disableContinue ? (
						<Button
							type="link"
							style={{ color: "orange" }}
							htmlType="button"
							onClick={this.onResendOTP}
						>
							Resend code &#62;
						</Button>
					) : (
						""
					)}
					{!this.state.enableResendBtn &&
					this.state.otp_sent &&
					!this.state.disableContinue ? (
						<p>
							<a
								style={{ color: "blue" }}
								// biome-ignore lint/a11y/useValidAnchor: <explanation>
								onClick={() => {
									this.onrelogin();
								}}
							>
								Click here
							</a>{" "}
							to go back to login screen
						</p>
					) : (
						""
					)}
				</Card>
			);
		};
		return (
			<div className="str-modal-container">
				<IdleTimer
					ref={(ref) => {
						this.idleTimer = ref;
					}}
					timeout={1000 * 60 * this.state.timeout}
					onIdle={this.handleOnIdle}
					onAction={this.handleOnAction}
					eventsThrottle={1000 * 60}
				/>
				<Modal
					className="str-modal-container"
					open={this.state.visible}
					centered
					footer={null}
					closable={false}
				>
					<React.Fragment>
						<div className="signin-page">
							<section className="">
								<img
									src={timer}
									alt=""
									style={{
										display: "block",
										marginLeft: "auto",
										marginRight: "auto",
										width: "18%",
									}}
								/>
								<div
									style={{
										textAlign: "center",
										fontSize: "20px",
										color: "rgba(0,0,0,.65)",
										marginBottom: "24px",
										fontWeight: "500",
									}}
								>
									Session expired. Re-enter your password
								</div>
								<div className="login-inner-container">
									{!this.state.otp_sent ? captchaCrtls() : tfa_ctrl_grid()}
								</div>
								<Loader loading={this.state.loading} />
							</section>
						</div>
					</React.Fragment>
				</Modal>
			</div>
		);
	}

	inputEntered = (feildName, value) => {
		const values = {
			...this.state.formData,
		};
		values[feildName] = value ? value : "";
		this.setState({
			formData: { ...values },
			loginError: null,
		});
	};

	onChangeOtp = (e) => {
		this.setState({ otp: e.target.value });
	};

	captureValidFlag = (feildName, value) => {
		const values = {
			...this.state.valid,
		};
		values[feildName] = value;
		this.setState({
			valid: {
				...values,
				valid: values.email && values.password,
			},
		});
	};

	onSubmit = async (e) => {
		this.setState({ disableButton: true });

		let data = {};
		if (this.state.otp_sent) {
			data = {
				email: this.state.formData.email.toLowerCase(),
				otp: this.state.otp,
			};
		} else {
			data = {
				identifier: this.state.formData.email.toLowerCase(),
				password: this.state.formData.password,
				recaptchaValue: this.state.recpatchaValue,
			};
		}

		try {
			e.preventDefault();
			// call the  signin api
			if (
				!(constants.captcha_whitelist.includes(hostname)
					? !this.state.valid.valid || !this.state.recaptchaValidation
					: !this.state.valid.valid)
			) {
				let urlTobeCalled = "";
				if (this.state.otp_sent) {
					if (this.state.otp) {
						urlTobeCalled = constants.otpValidation;
						this.setState({ req_type: "OTP_VALIDATION" });
						this.onloaderStart();
					} else {
						return Alert.error(
							"OTP code is mandatory.",
							constants.alertDuration,
						);
					}
				} else {
					urlTobeCalled = constants.userSignIn;
					this.setState({ req_type: "PWD_VALIDATION" });
				}
				const response = await api.post(urlTobeCalled, data);

				if (response.status !== 200) {
					this.setState({ disableButton: false });
					Alert.error("Unable to login");
					if (this.state.req_type === "OTP_VALIDATION") {
						this.setState({ incorrect_otp: true });
					}
					this.onloadingComplete();
				} else {
					if (this.state.req_type === "PWD_VALIDATION") {
						if (response.data.user.enterprise !== null) {
							console.log(
								"TFA enabled status : ",
								response.data.user.enterprise.tfa_enabled,
							);
							if (!response.data.user.enterprise.tfa_enabled) {
								this.pageRedirection(response);
							} else {
								this.setState({ otp_sent: true });
								if (!response.data.tfa.enable_resend) {
									this.setState({ enableResendBtn: false });
								}
							}
						} else {
							console.log(
								"Enterprise not enabled for this user account so we redirect to Dashboard ...",
							);
							this.pageRedirection(response);
						}
					} else if (this.state.req_type === "OTP_VALIDATION") {
						this.pageRedirection(response);
					} else {
						console.log("Unhandled exception so we redirect to Dashboard ...");
						this.pageRedirection(response);
					}
					this.onloadingComplete();
				}
			}
			this.setState({ disableButton: false });
		} catch (error) {
			this.onloadingComplete();
			console.log("error", error.response);
			if (error.response?.data.message[0].messages[0].disable_btn) {
				this.setState({ disableContinue: true });
			}
			if (
				error.response &&
				error.response.data.message[0].messages[0].status === "IC"
			) {
				this.setState({ isCodeIncorrect: true });
			}
			const value = localStorage.getItem("popUpValue");
			if (constants.captcha_whitelist.includes(hostname)) {
				recaptchaRef.current.reset();
			}
			if (value === null) {
				if (error.response?.data.message[0].messages[0].disable_btn) {
					Alert.error(
						error?.response ? (
							<p>
								Due to too many invalid login attempts, your account is locked.
								Please contact{" "}
								<a href="mailto:me-support@satisfilabs.com">Support</a>
							</p>
						) : (
							null || "Something went wrong"
						),
						this.state.alertTime,
						() => localStorage.removeItem("popUpValue"),
					);
				} else {
					localStorage.setItem("popUpValue", "1");
					Alert.error(
						error?.response
							? error.response.data.message[0].messages[0].message
							: null || "Something went wrong",
						constants.alertDuration,
						() => localStorage.removeItem("popUpValue"),
					);
				}
			} else if (
				error.response?.data.message[0].messages[0].disable_btn ||
				(error.response &&
					error.response.data.message[0].messages[0].status === "IC")
			) {
				if (
					error.response &&
					error.response.data.message[0].messages[0].status === "IC"
				) {
					Alert.error(
						error?.response
							? error.response.data.message[0].messages[0].message
							: null || "Something went wrong",
						constants.alertDuration,
						() => localStorage.removeItem("popUpValue"),
					);
				} else if (error.response?.data.message[0].messages[0].disable_btn) {
					Alert.error(
						error?.response ? (
							<p>
								Due to too many invalid login attempts, your account is locked.
								Please contact{" "}
								<a href="mailto:me-support@satisfilabs.com">Support</a>
							</p>
						) : (
							null || "Something went wrong"
						),
						this.state.alertTime,
						() => localStorage.removeItem("popUpValue"),
					);
				}
			}

			this.setState({
				recaptchaValidation: false,
				disableButton: false,
			});
		}
	};

	onChangeRecaptcha = (value) => {
		this.setState({
			recaptchaValidation: true,
			recpatchaValue: value,
		});
	};

	onExpiredRecaptcha = () => {
		this.setState({
			recaptchaValidation: false,
		});
	};

	onErrorRecaptcha = () => {
		this.setState({
			recaptchaValidation: false,
		});
	};

	setCaretPosition = (ctrl, pos) => {
		// Modern browsers
		if (ctrl.setSelectionRange) {
			ctrl.focus();
			ctrl.setSelectionRange(pos, pos);

			// IE8 and below
		} else if (ctrl.createTextRange) {
			const range = ctrl.createTextRange();
			range.collapse(true);
			range.moveEnd("character", pos);
			range.moveStart("character", pos);
			range.select();
		}
	};

	showPasswordHandler = () => {
		this.setState({ showPassword: !this.state.showPassword }, () => {
			setTimeout(() => {
				const input = document.getElementById("custom-css-outlined-input_1");
				this.setCaretPosition(input, input.value.length);
			}, 0);
		});
	};

	pageRedirection = async (response) => {
		this.setState({ loading: true });
		//storing the user_token
		window.localStorage.setItem("id", response.data.user.id);
		window.localStorage.setItem("user_token", response.data.jwt);
		window.localStorage.setItem("username", response.data.user.username);
		window.localStorage.setItem(
			"firstname",
			response.data.user.firstname || response.data.user.username,
		);
		window.localStorage.setItem("email", response.data.user.email);
		response.data.user.enterprise
			? window.localStorage.setItem(
					"enterprise_id",
					response.data.user.enterprise.id,
				)
			: null;
		if (response.data.user.enterprise) {
			window.localStorage.setItem(
				"org_name",
				response.data.user.enterprise.org_name,
			);
		} else {
			window.localStorage.setItem("org_name", "Enterprise Name");
		}
		const claims_req = {
			method: "GET",
			url: constants.claims,
			headers: {
				"Content-Type": "application/json",
				Authorization: `Bearer ${response.data.jwt}`,
			},
		};

		const claims_resp = await axios(claims_req);

		let MAIN_DASH = true;
		let DNS_VALIDATION = true;

		if ([200, 201].includes(claims_resp.status)) {
			if (claims_resp.data?.data && claims_resp.data.data.length > 0) {
				for (const claim of claims_resp.data.data) {
					if (claim.feature === "MAIN_DASH" && claim.disabled) {
						MAIN_DASH = false;
					} else if (claim.feature === "DNS_VALIDATION" && claim.disabled) {
						DNS_VALIDATION = false;
					}
				}
			}
		}

		/**
		 * set claims in localstorage
		 */
		window.localStorage.setItem("MAIN_DASH", MAIN_DASH.toString());
		window.localStorage.setItem("DNS_VALIDATION", DNS_VALIDATION.toString());

		if (response.data.user.enterprise) {
			window.localStorage.setItem(
				"factcube_enabled",
				response.data.user.enterprise.factcube_enabled !== undefined
					? response.data.user.enterprise.factcube_enabled
					: false,
			);

			window.localStorage.setItem(
				"dash_currency",
				response.data.user.enterprise.currency !== null
					? response.data.user.enterprise.currency
					: "$",
			);
		}
		this.setState({ loading: false, visible: false });
	};

	onResendOTP = async (e) => {
		this.onloaderStart();
		const data = {
			email: this.state.formData.email.toLowerCase(),
		};
		let response;
		try {
			e.preventDefault();
			response = await api.post(constants.resendOTP, data);
			if (response.status !== 200) {
				this.setState({ disableButton: false });
				Alert.error(response.error, constants.alertDuration);
				this.onloadingComplete();
			} else {
				console.log(response);
				console.log(response.data.tfa.enable_resend);
				if (!response.data.tfa.enable_resend) {
					this.setState({ enableResendBtn: false });
				}
				console.log("OTP resend successfully");
				this.onloadingComplete();
			}
		} catch (error) {
			this.onloadingComplete();
			console.log("ERROR resendOTP : ", error);
			Alert.error(
				error.response.data.message[0].messages[0].message ||
					"Something went wrong",
				constants.alertDuration,
				() => localStorage.removeItem("popUpValue"),
			);
		}
	};
}

export default (props) => (
	<TimeoutContext.Consumer>
		{({ timeout }) => {
			return <LoginPopUp {...props} timeout={timeout} />;
		}}
	</TimeoutContext.Consumer>
);
